<template>
  <div class="ScrollBox">
    <van-nav-bar
      :border="false"
      left-arrow
      @click-left="$router.go(-1)"
      style="background:transparent;position:absolute;width:100%"
    />
    <div class="PromoteInfo" :style="`background-image: url('./static/images/${Theme}/promote_bg_new.png')`">
      <div v-if="InitData.yqwa&&InitData.yqwa.length" class="activity-title" v-html="InitData.yqwa[0].content"></div>
      <div class="red-packet">
        <div class="box">
          <div v-if="InitData.yqwa&&InitData.yqwa.length" class="item" v-for="item,index in InitData.yqwa.slice(1,3)" :key="index" v-html="item.content"></div>
        </div>
      </div>
      <div class="red-packet-mark">
        <a class="btn" href="javascript:;" @click="showShare=true">{{$t('promote[5][2]')}}</a>
        <img :src="`./static/images/${Theme}/promote_bg_mark.png`" width="100%">
      </div>
      <div style="padding:0 15px;overflow:hidden">
        <div v-if="directlyRewardList.length" class="group-box">
          <div class="title">
            <h1>{{directlyInfo.title}}</h1>
            <p>{{directlyInfo.dec}}</p>
          </div>
          <div class="reward-list directly-reward">
            <div class="item" v-for="item,index in directlyRewardList" :key="index">
              <div class="left">
                <i>{{index>9?(index+1):`0${index+1}`}}</i>
              </div>
              <div class="con">
                {{item.title}}
                <p><a href="javascript:;" @click="detailInfo=item.content,showDetail=true">{{$t('promote[19]')}}</a><van-icon name="arrow" /></p>
              </div>
              <div class="right">
                <div class="reward">+{{InitData.currency}}{{item.reward}}</div>
                <van-button v-if="item.invitedNum<item.member" size="mini" color="linear-gradient(#fe9551,#e27159)" @click="showShare=true">{{$t('promote[5][0]')}}</van-button>
                <van-button v-else size="mini" color="linear-gradient(#fe9551,#e27159)" :disabled="item.is_reward==1?true:false" @click="receiveReward(item.id)">{{$t('promote[5][1]')}}</van-button>
                <p>{{item.invitedNum}}/{{item.member}}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="rewardList.length" class="group-box">
          <div class="title">
            <h1>{{rewardInfo.title}}</h1>
            <p>{{rewardInfo.dec}}</p>
          </div>
          <div class="reward-list">
            <div class="item" v-for="item,index in rewardList" :key="index">
              <div class="left">
                <i>{{index+1}}</i>
              </div>
              <div class="con">
                {{item.title}}<span>+{{InitData.currency}}{{item.reward}}</span>
                <p v-html="item.content"></p>
              </div>
              <div class="right">
                <van-button v-if="UserInfo.member<item.member" round size="small" color="linear-gradient(#ff9555,#ff4035)" style="font-size:14px;padding:0 15px" @click="showShare=true">{{$t('promote[5][0]')}}</van-button>
                <van-button v-else round size="small" color="linear-gradient(#ff9555,#ff4035)" style="font-size:14px;padding:0 15px" :disabled="item.is_reward==1?true:false" @click="receiveReward(item.id)">{{$t('promote[5][1]')}}</van-button>
                <p>{{UserInfo.member}}/{{item.member}}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="InitData.vipReward.length" class="group-box">
          <div class="title">
            <h1>{{vipInfo.title}}</h1>
            <p>{{vipInfo.dec}}</p>
          </div>
          <ul class="vip-list">
            <li v-for="item,index in InitData.vipReward" :key="index">
              <h4>{{item.title}}</h4>
              <div v-html="item.content"></div>
            </li>
          </ul>
        </div>
        <div v-if="teamRewardList.length" class="group-box">
          <div class="title">
            <h1>{{$t('promote[6]')}}</h1>
          </div>
          <ul class="star-list">
            <li v-for="item,index in teamRewardList" :key="index">
              <img :src="`./static/images/${Theme}/${index+1}star-bg.png`" width="100%">
              <span>{{InitData.currency}}{{item.reward}}</span>
            </li>
          </ul>
          <div class="team-list">
            <div class="top">
              <van-image class="head" :src="`./static/head/${UserInfo.header}`" round width="54" />
              <div class="con">
                <h4>{{UserInfo.vip_team}}{{$t('promote[7][0]')}}</h4>
                <van-rate v-model="UserInfo.vip_team" color="#f82d02" void-icon="star" void-color="#99672c" size="14" :count="teamRewardList.length" />
              </div>
              <div class="right">
                <h4>{{$t('promote[7][1]')}}:{{UserInfo.team_bonus}}</h4>
                <p>{{$t('promote[7][2]')}}:{{UserInfo.team_wage}}</p>
              </div>
            </div>
            <div class="item" v-for="item,index in teamRewardList" :key="index">
              <div class="left">
                <div>{{item.member}}<small>{{$t('promote[8][0]')}}</small></div>
              </div>
              <div class="con">
                <h3>{{item.title}}</h3>
                <div v-html="$t('promote[8][1]')+':'+item.content"></div>
                <div>{{$t('promote[8][2]')}}:{{item.invitedNum}}{{$t('promote[8][0]')}}</div>
              </div>
              <div class="right">
                <van-button round size="small" block color="linear-gradient(#ff9555,#ff4035)" :disabled="item.is_reward==1?true:false" @click="receiveReward(item.id)">{{$t('promote[5][1]')}} {{InitData.currency}}{{item.reward}}</van-button>
              </div>
            </div>
          </div>
          <van-button round block color="linear-gradient(#ff9555,#ff4035)" style="font-size: 15px;font-weight: 600;box-shadow: 0 2px 5px rgba(198, 36, 17, .3);margin-bottom: 10px" @click="showShare=true">{{$t('promote[5][2]')}}</van-button>
        </div>
        <div v-if="InitData.commission_description" class="group-box">
          <div class="title">
            <h1>{{$t('promote[9]')}}</h1>
          </div>
          <div class="commission-info">
            <img :src="`./static/images/${Theme}/commission-img.png`" width="100%">
            <div class="con" v-html="InitData.commission_description"></div>
          </div>
        </div>
        <div class="group-box">
          <div class="title">
            <h1>{{$t('promote[10][0]')}}</h1>
            <!-- <p>{{$t('promote[10][1]')}}<b>{{InitData.currency}}{{shareTotal}}</b>{{$t('promote[0][2]')}}</p> -->
          </div>
          <div class="share-list">
            <div class="item" v-for="item,index in shareList" :key="index">
              <div class="left">
                <img :src="`./static/images/${Theme}/promote-icon${index+1}.png`">
              </div>
              <div class="con">
                {{item.title}}
                <p v-html="item.content"></p>
              </div>
              <div class="right">
                <van-button round size="small" color="linear-gradient(#ff9555,#ff4035)" style="font-size:14px;padding:0 15px" @click="shareFriend">{{index==0?$t('promote[11][1]'):$t('promote[5][0]')}}</van-button>
                <!-- <p>{{item.invitedNum}}/{{item.member}}</p> -->
              </div>
            </div>
            <!-- <div class="item">
              <div class="left">
                <img :src="`./static/images/${Theme}/promote-icon3.png`">
              </div>
              <div class="con">
                {{$t('promote[12][0]')}}
                <p>{{$t('promote[12][1]')}} {{InitData.currency}}{{UserInfo.recharge_money}}</p>
              </div>
              <div class="right">
                <van-button round size="small" color="linear-gradient(#ff9555,#ff4035)" style="font-size:14px;padding:0 15px" to="/user/recharge">{{$t('promote[12][2]')}}</van-button>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <img :src="`./static/images/${Theme}/promote-icon4.png`">
              </div>
              <div class="con">
                {{$t('promote[13][0]')}}
                <p>{{$t('promote[13][1]')}} {{InitData.currency}}{{UserInfo.mining_money}}</p>
              </div>
              <div class="right">
                <van-button round size="small" color="linear-gradient(#ff9555,#ff4035)" style="font-size:14px;padding:0 15px" @click="openMining">{{$t('promote[13][2]')}}</van-button>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <img :src="`./static/images/${Theme}/promote-icon5.png`">
              </div>
              <div class="con">
                {{$t('promote[14][0]')}}
                <p>{{$t('promote[14][1]')}} {{InitData.currency}}{{UserInfo.investment_money}}</p>
              </div>
              <div class="right">
                <van-button round size="small" color="linear-gradient(#ff9555,#ff4035)" style="font-size:14px;padding:0 15px" @click="openFinance">{{$t('promote[14][2]')}}</van-button>
              </div>
            </div> -->
          </div>
        </div>
        <van-button round block color="linear-gradient(#ff9555,#ff4035)" style="font-size: 15px;font-weight: 600;box-shadow: 0 2px 5px rgba(198, 36, 17, .3);margin: 30px 0" @click="showShare=true">{{$t('promote[5][2]')}}</van-button>
      </div>
    </div>
    <van-share-sheet
      v-model="showShare"
      :title="$t('promote[15][0]')"
      :options="shareOptions"
      @select="onSelectShare"
    >
      <template #description>
        <div class="code">{{$t('promote[15][1]')}} <span id="IosCode">{{UserInfo.idcode}}</span><input type="text" id="AppCode" :value="UserInfo.idcode" style="position: absolute;opacity: 0;z-index: -1"></div>
        <input type="text" id="AppLink" :value="promoteUrl">
        <span id="IosLink" style="position: absolute;opacity: 0;z-index: -1">{{promoteUrl}}</span>
      </template>
    </van-share-sheet>
    <van-action-sheet 
      v-model="showQrcode" 
      :title="$t('promote[16][2]')"
      :closeable="false"
      close-on-popstate
      :cancel-text="$t('promote[17]')"
      @cancel="saveQRCode(qrcodeImg)"
    >
      <div class="qrcode-con">
        <van-image :src="qrcodeImg" width="70%" />
      </div>
    </van-action-sheet>
    <van-action-sheet 
      v-model="showPoster" 
      :title="$t('promote[16][3]')"
      :closeable="false"
      close-on-popstate
      :cancel-text="$t('promote[17]')"
      @cancel="savePoster"
    >
      <div ref="posterDom" class="poster-dom">
        <div v-if="InitData.yqwa&&InitData.yqwa.length" class="activity-title" v-html="InitData.yqwa[0].content"></div>
        <div class="red-packet">
          <div class="mark"></div>
          <div class="box" style="padding-bottom: 70px;">
            <div v-if="InitData.yqwa&&InitData.yqwa.length" class="item" v-for="item,index in InitData.yqwa.slice(1,3)" :key="index" v-html="item.content"></div>
            <img :src="qrcodeImg" width="70%" style="display:block;margin:20px auto 0;">
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-share-sheet
      v-model="showSocial"
      :title="$t('promote[15][0]')"
      :options="socialOptions"
      @select="onSelectSocial"
    />
    <van-popup v-model="showDetail" round style="width: 90%;padding:10px;">
      <div class="directly-con" v-html="detailInfo"></div>
    </van-popup>
  </div>
</template>

<script>
import QRCode from "qrcode"
import Html2Canvas from "html2canvas"
export default {
  name: 'Promote',
  components: {
  },
  props: ['isReward'],
  data() {
    return {
      promoteUrl: '',
      saveN: 0,
      showReward: false,
      docTitle: document.title,
      topList: [{
        member: 0,
        reward: 0
      }],
      rewardInfo: {
        title: '',
        dec: ''
      },
      vipInfo: {
        title: '',
        dec: ''
      },
      rewardList: [{
        member: 0,
        reward: 0
      }],
      teamRewardList: '',
      shareList: '',
      shareTotal: 0,
      showShare: false,
      shareOptions: [
        [
          { name: this.$t('promote[16][0]'), icon: './static/icon/share-sheet-link.png', type: 'link'},
          { name: this.$t('promote[16][1]'), icon: './static/icon/share-sheet-code.png', type: 'code'},
          { name: this.$t('promote[16][2]'), icon: './static/icon/share-sheet-qrcode.png', type: 'qrcode'},
          { name: this.$t('promote[16][3]'), icon: './static/icon/share-sheet-poster.png', type: 'poster'}
        ]
      ],
      showQrcode: false,
      qrcodeImg: '',
      showPoster: false,
      showSocial: false,
      directlyInfo: {
        title: '',
        dec: ''
      },
      directlyRewardList: [{
        member: 0,
        reward: 0
      }],
      detailInfo: '',
      showDetail: false,
    }
  },
  computed: {
    socialOptions() {
      return this.$store.state.InitData.shareApp.flatMap(item=>[{name: item.title, icon: this.$store.state.InitData.setting.up_url+item.cover_img,url: item.url}])
    }
  },
  watch: {

  },
  created() {
    this.$parent.navBarTitle = ''
    this.promoteUrl = `${this.$store.state.InitData.setting.reg_url}/#/register/${this.$store.state.UserInfo.idcode}`
    this.$Model.GetUserInfo()
    this.getRewardlist()
    QRCode.toDataURL(this.promoteUrl, (err, url) => {
      if (err) throw err
      this.qrcodeImg = url
    })
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    onSelectSocial(option) {
      this.$Util.OpenUrl(option.url+encodeURIComponent(this.promoteUrl))
    },
    shareFriend() {
      if(this.$store.state.InitData.shareApp.length){
        this.showSocial = true
      }else{
        this.showShare = true
      }
    },
    onSelectShare(option) {
      if(option.type=='link'){
        this.$Util.CopyText('IosLink','AppLink')
      }
      if(option.type=='code'){
        this.$Util.CopyText('IosCode','IosCode')
      }
      if(option.type=='qrcode'){
        this.showQrcode = true
        this.showShare = false
      }
      if(option.type=='poster'){
        this.showPoster = true
        this.showShare = false
      }
    },
    openMining() {
      if(this.$store.state.InitData.setting.is_mining==1){
        this.$router.push('/mine')
      }else{
        this.$Dialog.Toast(this.$t('dialog[7]'))
      }
    },
    openFinance() {
      if(this.$store.state.InitData.setting.is_financial==1){
        this.$router.push('/finance')
      }else{
        this.$Dialog.Toast(this.$t('dialog[7]'))
      }
    },
    receiveReward(id) {
      this.$Model.ReceiveReward({id: id},data=>{
        if(data.code==1){
          this.getRewardlist()
        }
      })
    },
    getRewardlist() {
      this.$Model.GetRewardlist(data=>{
        if(data.directlyInfo){
          this.directlyInfo = data.directlyInfo
        }
        if(data.rewardInfo){
          this.rewardInfo = data.rewardInfo
        }
        if(data.vipInfo){
          this.vipInfo = data.vipInfo
        }
        this.directlyRewardList = data.directlyRewardList
        this.rewardList = data.rewardList
        this.topList = data.rewardList.filter(item=>item.topSort)
        this.topList.sort((a, b) => a.topSort - b.topSort);
        this.teamRewardList = data.teamRewardList
        this.shareList = data.shareList
        this.shareList.forEach(item=>{
          this.shareTotal += Number(item.reward)
        })
      })
    },
    savePoster() {
      Html2Canvas(this.$refs.posterDom).then((canvas) => {
        this.saveQRCode(canvas.toDataURL())
      });
    },
    saveQRCode(imgUrl) {
      if(window.plus){
        this.saveN+=1
        var img = imgUrl.replace('data:image/png;base64,','');
        var bm = new plus.nativeObj.Bitmap();
        bm.loadBase64Data(img, ()=>{
          bm.save( '_doc/promote'+this.saveN+'.jpg', {'overwrite':true,'format':'jpg'}, (e)=>{
            plus.gallery.save( e.target, (e)=>{
              this.$Dialog.Toast(this.$t('dialog[8]'))
            },(err)=>{  
              this.$Dialog.Toast(this.$t('dialog[9]'))
            }); 
          }, (error)=>{
            this.$Dialog.Toast(this.$t('dialog[9]'))
          });
          setTimeout(function(){
            bm.recycle();
          },1000);
        }, (err)=>{  
          this.$Dialog.Toast(this.$t('dialog[9]'))
        });
      }else{
        this.downCanvas(imgUrl)
      }
    },
    downCanvas(url) {
      var a = document.createElement('a')
      var event = new MouseEvent('click')
      a.download = 'promote'
      a.href = url
      a.dispatchEvent(event)
      if(!url){
        this.$Dialog.Toast(this.$t('promote[10]'))
      }
    },
  }
}
</script>
<style scoped>
.van-nav-bar>>>.van-icon{
  color: var(--color-white);
}
.PromoteInfo{
  background-repeat: no-repeat;
  background-size: 100%;
  background-color: #f7cb95;
  min-height: 100%;
  padding-top: 46px;
  line-height: 1;
}
.activity-title {
  text-align: center;
  padding: 0 10px;
  color: var(--color-white);
  margin-top: -20px;
}
.activity-title>>>h1{
  font-size: 20px;
  margin: 8px 0;
  text-shadow: 1px 2px 0 #000;
  font-weight: 600;
}
.activity-title>>>h2{
  font-size: 13px;
  text-shadow: 1px 2px 0 #000;
  font-weight: 600;
}
.activity-title>>>h4{
  font-size: 12px;
  text-shadow: 1px 2px 0 #000;
}
.red-packet{
  position: relative;
  padding: 0 20%;
  margin-top: 10px;
  text-align: center;
}
.red-packet .box{
  background: url('../../../public/static/images/default/red_packet.png') no-repeat;
  background-size: 100%,100%;
  min-height: 180px;
  position: relative;
}
.red-packet .box .item{
  padding: 9px 25px;
}
.red-packet .box .item>>>p{
  color: #fa0021;
}
.red-packet .box .item>>>h2{
  font-size: 20px;
  font-weight: 600;
  background-image: linear-gradient(#fd9736,#fa2537);
  background-clip:text;
  -webkit-background-clip:text;
  color: transparent;
  margin: 5px 0;
}
.red-packet .box .item>>>h2 small{
  font-size: 18px;
}
.red-packet .box .btn{
  position: absolute;
  top: 210px;
  left: 20px;
  right: 20px;
  background: url('../../../public/static/images/default/red_packet_btn.png') no-repeat;
  background-size: 100% 100%;
  height: 50px;
  color: #7b532e;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  z-index: 99;
}
.group-box {
  background-color: var(--background-main);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 5px rgba(172, 133, 53, .3);
  margin: 20px 0;
}
.group-box .title{
  text-align: center;
  font-size: 12px;
  padding: 10px 0;
}
.group-box .title b{
  color: #fd0000;
  margin: 0 3px;
}
.group-box .title h1{
  font-size: 20px;
  display: inline-block;
  padding: 0 65px;
  background: url('../../../public/static/images/default/title-bg-left.png') no-repeat 0 center,url('../../../public/static/images/default/title-bg-right.png') no-repeat right center;
  background-size: auto 14px;
  margin-bottom: 10px;
  font-weight: 600;
}
.reward-list .item{
  margin-top: 10px;
  background-color: var(--background-main);
  box-shadow: 0 0 5px rgba(252, 95, 53, .5);
  border-radius: 10px;
  padding: 15px 15px 15px 0;
  display: flex;
}
.reward-list .item .left i{
  display: block;
  background: url('../../../public/static/images/default/number-bg.png') no-repeat;
  background-size: auto 100%;
  padding: 5px 15px 8px;
  color: #fff;
  text-align: center;
  margin-left: -5px;
  margin-top: -6px;
}
.directly-reward .item .left i{
  background-image: url('../../../public/static/images/default/number-bg_new.png');
  padding: 13px;
  margin-left: -13px;
}
.reward-list .item .con{
  flex: 1;
  margin: 0 10px 0 5px;
  font-size: 16px;
  font-weight: 600;
}
.reward-list .item .con span{
  color: #ff0000;
  margin-left: 5px;
}
.reward-list .item .con p{
  font-size: 12px;
  color: var(--color-assist);
  margin-top: 18px;
  font-weight: 400;
}
.reward-list .item .right{
  text-align: center;
}
.reward-list .item .right>p{
  color: var(--color-assist);
  margin-top: 8px;
}
.star-list {
  display: flex;
}
.star-list li{
  flex: 1;
  position: relative;
}
.star-list li span{
  position: absolute;
  bottom: 10px;
  left: 5px;
  right: 5px;
  text-align: center;
  font-weight: 600;
  color: #ffca58;
}
.star-list li+li{
  margin-left: 13px;
}
.team-list{
  background-color: #ffc887;
  border-radius: 10px;
  padding: 15px 5px;
  margin: 15px 0;
}
.team-list .top{
  padding: 0 10px;
  display: flex;
  align-items: center;
}
.team-list .top .head{
  border:2px solid #ffeaba;
  background-color:#99672c
}
.team-list .top .con{
  flex: 1;
  margin: 0 10px;
}
.team-list .top h4{
  font-size: 15px;
  margin-bottom: 10px;
}
.team-list .top p{
  color: #99672c;
}
.team-list .top .right{
  text-align: right;
}
.team-list .item{
  display: flex;
  background: url('../../../public/static/images/default/team-bg-left.png') no-repeat 0 center;
  background-size: 20px 100%;
  padding-left: 20px;
}
.team-list .item>div{
  display: flex;
  align-items: center;
}
.team-list .item .left{
  background: url('../../../public/static/images/default/team-bg.png') repeat-x 0 center;
  background-size: auto 100%, auto 100%;
}
.team-list .item .left div{
  background: linear-gradient(#ffcd87,#ffedc0);
  border: 1px solid #ffecbe;
  display: flex;
  justify-content: center;
  padding: 10px 5px;
  min-width: 60px;
  font-size: 30px;
  color: #f82d02;
  font-weight: 600;
  align-items: flex-end;
}
.team-list .item .left div small{
  font-size: 12px;
  margin-bottom: 5px;
}
.team-list .item .con{
  background: url('../../../public/static/images/default/team-bg.png') repeat-x 0 center;
  background-size: auto 100%;
  flex: 1;
  padding: 15px 0 15px 10px;
  flex-direction: column;
  align-items: flex-start;
}
.team-list .item .con h3{
  font-size: 15px;
  color: #fc5f35;
  font-weight: 600;
  padding-bottom: 5px;
}
.team-list .item .con div{
  color: #7a1305;
  font-size: 12px;
  margin-top: 5px;
}
.team-list .item .con div>>>*{
  color: #7a1305;
  font-size: 12px;
  display: inline-block;
}
.team-list .item .right{
  width: 33.33%;
  padding: 0 15px 0 20px;
  background: url('../../../public/static/images/default/team-bg-right.png') no-repeat right center;
  background-size: 100% 100%;
  box-sizing: content-box;
}
.commission-info{
  padding: 15px 0;
}
.commission-info .con{
  background: url('../../../public/static/images/default/commission-bg-bottom.png') no-repeat center bottom,url('../../../public/static/images/default/commission-bg.png') no-repeat center 0,url('../../../public/static/images/default/commission-bg-con.png') repeat-y center;
  background-size: 100%,100%,100%;
  padding: 20px 95px 20px 20px;
  min-height: 130px;
  margin-top: 20px;
}
.commission-info .con>>>*{
  font-size: 14px;
  line-height: 1.5;
}
.commission-info>>>.list-paddingleft-2{
  padding-left: 16px;
}
.share-list .item{
  margin-top: 10px;
  background-color: var(--background-main);
  box-shadow: 0 0 5px rgba(252, 95, 53, .5);
  border-radius: 10px;
  padding: 15px;
  display: flex;
  align-items: center;
}
.share-list .item .left img{
  width: 46px;
  height: 46px;
  border-radius: 100%;
}
.share-list .item .con{
  flex: 1;
  margin: 0 10px;
  font-size: 16px;
  font-weight: 600;
}
.share-list .item .con span{
  color: #ff0000;
  margin-left: 5px;
}
.share-list .item .con p{
  font-size: 12px;
  color: var(--color-assist);
  margin-top: 10px;
  font-weight: 400;
}
.share-list .item .right{
  text-align: center;
}
.share-list .item .right>p{
  color: var(--color-assist);
  margin-top: 5px;
}
.van-share-sheet>>>.van-share-sheet__title{
  font-size: 16px;
  font-weight: 600;
}
.van-share-sheet>>>.van-share-sheet__options{
  padding-left: 0;
  justify-content: center;
}
.van-share-sheet>>>.van-share-sheet__description{
  overflow: hidden;
}
.van-share-sheet>>>.van-share-sheet__description .code{
  font-size: 14px;
  margin: 10px 0;
  color: var(--color-main);
}
.van-share-sheet>>>.van-share-sheet__description input{
  border: 1px solid var(--border-color-main);
  background-color: var(--background-theme);
  border-radius: 5px;
  font-size: 14px;
  color: var(--color-main);
  width: 100%;
  line-height: 1;
  padding: 12px 15px;
  text-align: center;
}
.van-share-sheet>>>.van-share-sheet__option{
  width: 25%;
  flex: none;
}
.van-share-sheet>>>.van-share-sheet__name{
  padding: 0 8px;
  text-align: center;
}
.qrcode-con{
  text-align: center;
  padding: 20px;
}
.poster-dom{
  background: url('../../../public/static/images/default/promote_bg.png') no-repeat #fbe5b8;
  background-size: 100%;
  padding: 40px 0 20px;
}
.poster-dom .red-packet .box .item h2{
  color: #fa2537;
  background: none;
}
.vip-list{
  display: flex;
  text-align: center;
  line-height: 1;
  background-color: #fff6f6;
  border-radius: 10px;
  padding: 20px 0;
}
.vip-list li{
  width: 33.33%;
  font-size: 24px;
  color: var(--color-important);
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vip-list li+li{
  border-left: 1px #feded6 solid;
}
.vip-list li h4{
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 12px;
  color: var(--color-main);
}
.red-packet-mark{
  margin-top: -80px;
  position: relative;
  z-index: 2;
}
.red-packet-mark .btn{
  position: absolute;
  left: 30%;
  right: 30%;
  bottom: 55px;
  background: url('../../../public/static/images/default/red_packet_btn.png') no-repeat;
  background-size: 100% 100%;
  height: 36px;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  z-index: 99;
}

.directly-reward .item .con a{
  text-decoration: underline;
  color: #999;
}
.directly-reward .item .right{
  text-align: right;
}
.directly-reward .item .right .reward{
  color: #ef9e44;
  font-size: 16px;
  margin-bottom: 5px;
}
.directly-reward .item .right .van-button{
  border-radius: 6px;
}
.directly-con>>>img{
  max-width: 100%;
  max-height: 100%;
}
</style>